/**
 * ## Console logger
 *
 * A module which `logger` depends on. For more info, check out the `logger` module.
 *
 * @module module:modules/logger-types/console
 *
 * @see module:modules/logger
 *
 * @private
 */

/* eslint-disable no-console */
const log = (namespace, level, messages) => {
    const loggingArguments = [`${namespace}:`].concat([].slice.call(messages));
    console[level].apply(console, loggingArguments);
};

export default { log };
